<template>
    <div class="list">
        <!-- 面包屑导航区域 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>测试管理</el-breadcrumb-item>
            <el-breadcrumb-item>测试类型管理</el-breadcrumb-item>
        </el-breadcrumb>
    
        <!-- 卡片视图区域 -->
        <el-card>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-input placeholder="请输入测试" v-model="problem_title" clearable @clear="getTestList()">
                        <el-button slot="append" icon="el-icon-search" @click="getTestListSearch"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="openModal(true)">新增测试</el-button>
                </el-col>
            </el-row>
    
            <!-- 测试列表区域 -->
            <el-table :data="tableList" border stripe>
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column label="测试名称" prop="test_name"></el-table-column>
                <el-table-column label="测试描述" prop="test_desc"></el-table-column>
                <el-table-column label="图片">
                    <template slot-scope="scope">
                        <div class="imgbox">
                            <img class="commodity-img" :src="baseURL + scope.row.test_pic">
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="测试分类id" prop="test_classify_id"></el-table-column> -->
                <el-table-column label="操作" width="150px">
                    <template v-slot="scope">
                        <!-- 修改按钮 -->
                        <el-button type="primary" icon="el-icon-edit" size="mini" @click="openModal(false, scope.row)"></el-button>
                        <!-- 删除按钮 -->
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeClass(scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
    
        <!-- 新增 & 修改测试内容区域 -->
        <el-dialog :title="isAdd ? '新增测试' : '修改测试'" :visible.sync="isModal" width="66%" @close="closeModal">
            <el-form :model="formSource" ref="formSource" label-width="90px" :rules="rules">
                <el-form-item label="测试名称" prop="test_name" label-width="160px" required>
                    <el-input v-model="formSource.test_name" placeholder="请输入测试名称"></el-input>
                </el-form-item>
    
                <el-form-item label="测试分类" prop="test_classify_id" label-width="160px" required>
                    <el-select v-model="formSource.test_classify_id" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.id" :label="item.test_classify" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="测试描述" prop="test_desc" label-width="160px" required>
                    <el-input v-model="formSource.test_desc" placeholder="请输入测试描述"></el-input>
                </el-form-item>
                
    
                <el-form-item label="文章图片" label-width="160px" required>
                    <el-upload action="`${baseURL}uploadImg`" :http-request="upload" list-type="picture-card" :file-list="fileList" :limit="1" :on-change="imageChange" :on-exceed="exceedChange">
                        <i slot="default" class="el-icon-plus"></i>
                        <div slot="file" slot-scope="{file}">
                            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span v-if="fileList && fileList.length !== 0" class="el-upload-list__item-delete" @click="handleRemove(file)">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                    </el-upload>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="setClass">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 放大图片 -->
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="viewImage" alt="">
        </el-dialog>
    </div>
    </template>
    
    <script>
    export default {
        data() {
            return {
                baseURL: this.$http.defaults.baseURL,
                problem_title:'',
                options: [],
                isAdd: true, // 是否为新增测试 默认是
                tableList: [], // 表格数据源
                isModal: false, // 控制对话框的显示与隐藏
    
                formSource: {
                    id: null, // 测试id
                    test_name: '', // 测试名称
                    test_desc: '', // 测试描述
                    test_pic: '', // 测试图片
                    test_classify_id: null,
                }, // 表单数据
                dialogVisible: false,
                fileList: [], // 上传的图片数组
                viewImage: '', // 用于放大查看图片
                rules: {
                    test_name: [{
                        required: true,
                        message: '测试名不能为空!',
                        trigger: 'blur'
                    }],
                    test_desc: [{
                        required: true,
                        message: '测试描述不能为空!',
                        trigger: 'blur'
                    }],
                    test_classify_id: [{
                        required: true,
                        message: '请选择测试分类',
                        trigger: 'change'
                    }]
                }
            };
        },
        created() {
            this.getTestList(); // 获取测试类型列表
            this.getClassList(); // 获取测试分类
        },
        methods: {
            // 获取分类
            async getClassList() {
                const { data: res } = await this.$http.post('getTestClassifyList', {})
                if (res.status === 200) {
                    this.options = res.data
                } else {
                    this.$message.error(res.msg)
                }

            },
            async getTestList() {
                const {
                    data: res
                } = await this.$http.post('getTestList', {});
                if (res.status === 200) {
                    this.tableList = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            },
            async getTestListSearch(){
                const {
                    data: res
                } = await this.$http.post('getTestList', {test_name: this.problem_title});
                this.tableList = res.data;
            },
            // 上传图片
            async upload(f) {
                var formData = new FormData()
                formData.append('tweetPic', f.file, f.file.name)
                const { data: res } = await this.$http.post('uploadImg', formData)
                console.log(res, '======图片')
                if (res.status === 200) {
                    this.formSource.test_pic = res.data.localIamgeAddress
                } else {
                    this.$message.error(res.msg)
                }
            },
            // 打开文章信息的弹框
            setShopModal(isAdd, data) {
                this.isModal = true
                this.isAdd = isAdd
                if (!isAdd && data) {
                    this.formSource = JSON.parse(JSON.stringify(data));
                    this.fileList = [{ url: this.baseURL+data.test_pic }]
                }
            },
            clearSelection() {
                this.formSource.problem_type = null; // 清除选择
            },
            openModal(type, data) {
                this.isAdd = type;
                this.isModal = true;
                // 清空表单验证状态
                this.$nextTick(() => {
                  this.$refs.formSource.clearValidate();
                });
                if (!type) {
                    // 如果是编辑，那么拿一下编辑的内容
                    this.formSource = JSON.parse(JSON.stringify(data));
                }
            },
            async setClass() {
              // 先进行表单验证
              this.$refs.formSource.validate(async (valid) => {
                if (valid) {
                  // 验证通过，准备数据
                  let paramsData = {
                    ...this.formSource,
                  };
    
                  try {
                    if (this.isAdd) {
                      // 新增测试
                      const { data: res } = await this.$http.post('addTestList', paramsData);
                      if (res.status === 200) {
                        this.isModal = false;
                        this.getTestList();
                      } else {
                        this.$message.error(res.msg);
                      }
                    } else {
                      // 修改测试
                      const { data: res } = await this.$http.post('updateTestList', paramsData);
                      if (res.status === 200) {
                        this.isModal = false;
                        this.getTestList();
                      } else {
                        this.$message.error(res.msg);
                      }
                    }
                  } catch (error) {
                    this.$message.error('请求失败，请稍后再试');
                    console.error(error);
                  }
                } else {
                  // 验证失败，提示用户
                  this.$message.error('请检查表单内容');
                }
              });
            },
            imageChange(res, file) {
                console.log(res, file, '=====上传图片的信息')
                this.fileList = file // 图片信息发生变化时 赋值给图
            },
            handleRemove(file) {
                this.fileList = this.fileList.filter((item) => file.uid !== item.uid) // 保留除当前点击图片外的所有图片
            },
            // 放大图片
            handlePictureCardPreview(file) {
                this.viewImage = file.url
                this.dialogVisible = true
            },
            // 由于限制了上传图片的个数 此时提示用户
            exceedChange() {
                this.$message.error('文章图片仅支持上传一张')
            },
            removeClass(data) {
                this.$confirm('此操作将无法恢复, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消', 
                        type: 'warning'
                    })
                    .then(async () => {
                        const {
                            data: res
                        } = await this.$http.post('delTestList', {
                            id: data.id
                        });
                        if (res.status === 200) {
                            this.getTestList();
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                    .catch(() => {});
            },
            closeModal() {
                this.formSource = {
                    id: null,
                    test_name: '',
                    test_desc:'',
                    test_pic:'',
                    test_classify_id: null,
                };
                this.fileList = []
            }
        }
    };
    </script>
    
    <style lang="less" scoped>
    /* 可以在此处添加样式 */

    .imgbox {
        width: 60px;
        padding: 10px;
        padding-left: 0;
        position: relative;

        .status_ts {
            position: absolute;
            width: 60px;
            height: 60px;
            padding-top: 18px;
            top: 10px;
            left: 0;
            background: rgba(0, 0, 0, 0.5);
            text-align: center;
            color: #fff;
            display: inline-block;
            z-index: 1000;
            border-radius: 4px;
        }

        .commodity-img,
        .defaultimg {
            cursor: pointer;
            border-radius: 4px;
            transition: all 0.2s;
            border: 1px solid #f1f1f1;
            width: 60px;
            height: 60px;
        }

        .defaultimg {
            background: #e9e9e9;
            display: inline-block;
            text-align: center;
            padding-top: 15px;
        }

        
    }
    </style>
    